/**
 * Форматирование и тон статусов страницы «EXONN → E-Post». Суммы приходят
 * из центра в центах.
 */

import type { Tone } from "src/admin/exonn-common/format.ts";

export type InstallationStatus =
  | "ready"
  | "test_only"
  | "no_customer"
  | "inactive";

/** «1–3», «4–9», «10+» из начал ступеней (по возрастанию). */
export const rangeLabels = (starts: number[]): string[] =>
  starts.map((start, index) => {
    const next = starts[index + 1];

    if (next === undefined) {
      return `${start}+`;
    }

    return next - 1 === start ? `${start}` : `${start}–${next - 1}`;
  });

export const percentExample = (
  tiers: { min_pages: number; letter: number; extra: number }[],
  percent: number,
): { before: number; after: number } | null => {
  const tier = [...tiers]
    .sort((a, b) => b.min_pages - a.min_pages)
    .find((row) => row.min_pages <= 5);

  if (!tier) {
    return null;
  }

  const before = tier.letter + (5 - tier.min_pages) * tier.extra;

  return { before, after: before + Math.round((before * percent) / 100) };
};

export const installationTone = (status: InstallationStatus): Tone =>
  ({
    ready: "success",
    test_only: "info",
    no_customer: "warning",
    inactive: "grey",
  })[status] as Tone;

// Цветом — только то, что требует внимания; штатный путь нейтральный.
export const letterTone = (status: string): Tone => {
  if (["failed", "check_failed"].includes(status)) {
    return "error";
  }

  return ["lost_unconfirmed", "unknown", "awaiting_funds"].includes(status)
    ? "warning"
    : "grey";
};

// Названия продуктов Deutsche Post: одинаково в мастере, карточке, пакете и ценах.
const REGISTERED_LABELS: Record<string, string> = {
  Einschreiben: "Einschreiben",
  "Einwurf Einschreiben": "Einschreiben Einwurf",
  "Einschreiben eigenhändig": "Einschreiben Eigenhändig",
  "Einschreiben Rückschein": "Einschreiben Rückschein",
  "Einschreiben eigenhändig Rückschein":
    "Einschreiben Eigenhändig + Rückschein",
};

export const registeredLabel = (type: string): string =>
  REGISTERED_LABELS[type] ?? type;
